import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Icon from '../misc/Icons'
import { getItemPathSegments } from '../../utils/search/getItemPathSegments'

// Root -> leaf breadcrumb for a search item: the containing pack (if any)
// followed by the folder chain. Shared by the results rows and the preview
// panes so both surfaces always agree on the contents and the order of a path.
//
// `classPrefix` namespaces the container and segment classes (the two surfaces
// are styled independently). `linked` renders segments as router links — used on
// the results page, where stopPropagation keeps a click on the breadcrumb from
// also firing the row's click / double-click. Preview panes render plain text.
function SearchPathBreadcrumb({
  item, folders, classPrefix, linked,
}) {
  const segments = getItemPathSegments(item, folders)
  if (!segments.length) return null
  const stop = (e) => { e.stopPropagation() }
  return (
    <span className={classPrefix}>
      {segments.map((segment, idx) => (
        <React.Fragment key={segment.id}>
          {idx > 0 && <Icon name='chevron-right' />}
          {linked && segment.to ? (
            <Link
              to={segment.to}
              className={`${classPrefix}-segment`}
              onClick={stop}
              onMouseDown={stop}
            >
              {segment.label}
            </Link>
          ) : (
            <span className={`${classPrefix}-segment`}>{segment.label}</span>
          )}
        </React.Fragment>
      ))}
    </span>
  )
}

function mapStateToProps(state) {
  return { folders: state.folders }
}

export default connect(mapStateToProps)(SearchPathBreadcrumb)
